<template>
  <v-container>
    <template v-if="isPermitted(situationId)">
      <slot />
    </template>
    <template v-else>
      <v-col v-show="showMessage" cols="6" offset="3" class="text-center">
        <v-alert class="mt-5 d-inline-block" dense outlined type="error">
          ご利用のプランではこの機能はご利用いただけません。
        </v-alert>
      </v-col>
    </template>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import SitePermissionUtils from '@/mixins/site_permission_utils'

export default {
  name: 'ExtensionsPermissionGuard',
  mixins: [SitePermissionUtils],
  props: {
    situationId: {
      type: Number,
      required: true
    },
    showMessage: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  }
}
</script>

<style scoped></style>
